import { render, staticRenderFns } from "./index.vue?vue&type=template&id=04662604&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=04662604&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04662604",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FCSwiper: require('/opt/build/repo/apps/shop/components/FCSwiper.vue').default,ShopFooterSections: require('/opt/build/repo/apps/shop/components/shop/ShopFooterSections.vue').default})
